<template>
  <div
    class="common-head fb fb-main-center fb-cross-center"
    :style="`width: ${size}px; height: ${size}px;`"
  >
    <img v-if="headImgUrl" :src="headImgUrl" />
    <span v-else class="font-24">{{ computedName }}</span>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'commonHeadImg',
  components: {},
  props: {
    name: {
      // 头像姓名
      type: String,
      default: ''
    },
    headImgUrl: String, // 头像路径
    size: {
      // 头像大小
      type: Number,
      default: 40
    }
  },
  data() {
    return {}
  },
  computed: {
    computedName() {
      let _result = ''
      _result = this.name.slice(-2)
      return _result
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
  filters: {}
}
</script>

<style lang="scss" scoped>
.common-head {
  border-radius: 50%;
  overflow: hidden;
  background: #3296fa;
  > span {
    color: #ffffff;
  }
  > img {
    width: 100%;
    height: 100%;
  }
}
</style>
